import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=d38b4042"
import script from "./_slug.vue?vue&type=script&lang=js"
export * from "./_slug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ClinicMenu: require('/vercel/path0/components/clinicMenu.vue').default,Img: require('/vercel/path0/components/ui/img.vue').default,Staff: require('/vercel/path0/components/staff.vue').default,Slider: require('/vercel/path0/components/ui/slider.vue').default,ContactForm: require('/vercel/path0/components/contactForm.vue').default,Block: require('/vercel/path0/components/ui/block.vue').default})
